import { list } from "postcss";

export const translations = {
	luxorSeries: {
		h1_title: {
			en: "LUXOR SERIES",
			fr: "SÉRIE LUXOR",
		},
		h2_choose_your_model: {
			en: "Choose your model",
			fr: "Choisissez votre modèle",
		},
		luxor4_list: {
			en: [
				"4-wheel disc brakes",
				"Carplay & Android Auto touch screen",
				"Led lights",
				"Seatbelts",
				"48V 110Ah lithium battery",
				"Electric parking brake",
				"Rear view camera",
				"14 inch wheel",
				"Integrated charger",
				"Trunk",
				"AC Controller 400A",
				"Sound system with 10 speakers",
				"Turn signal, stop light",
				"6.3 kw Motor with EM brake",
			],
			fr: [
				"Freins à disque 4 roues",
				"Écran tactile Carplay & Android Auto",
				"Lumières LED",
				"Ceintures de sécurité",
				"Batterie lithium 48V 110Ah",
				"Frein de stationnement électrique",
				"Caméra de recul",
				"Roue de 14 pouces",
				"Chargeur intégré",
				"Coffre arrière",
				"Contrôleur AC 400A",
				"Système audio avec 10 haut-parleurs",
				"Clignotant, feu d'arrêt",
				"Moteur 6.3 kw avec frein EM",
			],
		},
		luxor4L_list: {
			en: [
				"4-wheel disc brakes",
				"Carplay & Android Auto touch screen",
				"Led lights",
				"Seatbelts",
				"48V 110Ah lithium battery",
				"Electric parking brake",
				"Rear view camera",
				"14 inch wheel",
				"Integrated charger",
				"Trunk",
				"Controller Curtis 400A",
				"Sound system with 10 speakers",
				"Turn signal, stop light",
				"6.3 kw Motor with EM brake",
				"Running boards",
				"Front bumper"
			],
			fr: [
				"Freins à disque 4 roues",
				"Écran tactile Carplay & Android Auto",
				"Lumières LED",
				"Ceintures de sécurité",
				"Batterie lithium 48V 110Ah",
				"Frein de stationnement électrique",
				"Caméra de recul",
				"Roue de 14 pouces",
				"Chargeur intégré",
				"Coffre arrière",
				"Contrôleur Curtis 400A",
				"Système audio avec 10 haut-parleurs",
				"Clignotant, feu d'arrêt",
				"Moteur 6.3 kw avec frein EM",
				"Marchepieds",
				"Pare-chocs avant",
			],
		},
		h3_colorPicker: {
			en: "Color Options",
			fr: "Options de couleur",
		},
		p_colorPicker: {
			en: "*Please note that due to variations between screens, actual colors may vary. Check with your dealer for actual colors.",
			fr: "*Veuillez noter qu'en raison des variations entre les écrans, les couleurs réelles peuvent varier. Vérifiez auprès de votre revendeur les couleurs réelles.",
		},
		p_touch_screen_compatible: {
			en: "Touchscreen compatible with Apple Carplay & Android Auto",
			fr: "Écran tactile compatible avec Apple Carplay & Android Auto",
		},
		p_touch_screen_aftermarks: {		
			en: "Apple CarPlay and Android Auto are aftermarket features, not included as part of the golf car's factory-installed products. Dealers may specify or offer these features separately. Additional fees may apply. Please check with your local dealer for details",
			fr: "Apple CarPlay et Android Auto sont des fonctionnalités après-vente, non incluses dans les produits installés en usine de la voiturette de golf. Les concessionnaires peuvent spécifier ou offrir ces fonctionnalités séparément. Des frais supplémentaires peuvent s'appliquer. Veuillez vérifier auprès de votre revendeur local pour plus de détails",
		},
		h2_span_discover: {
			en: "EXPLORE LUXOR SERIES",
			fr: "EXPLOREZ LA SÉRIE LUXOR",
		},
		h2_discover: {
			en: "Discover the comfort and innovation",
			fr: "Découvrez le confort et l'innovation",
		},
		h2_discoverNext: {
			en: "of our carts.",
			fr: "de nos voiturettes.",
		},
		p_discover: {
			en: "The Luxor Series offers a range of high-performance electric vehicles designed for both urban and off-road adventures. With cutting-edge technology and sleek designs, the Luxor Series is perfect for those who seek both style and functionality.",
			fr: "La série Luxor propose une gamme de véhicules électriques de hautes performances conçus pour les aventures urbaines et tout-terrain. Avec une technologie de pointe et des designs élégants, la série Luxor est parfaite pour ceux qui recherchent à la fois style et fonctionnalité.",
		},
		t_features_screen: {
			en: "9” MULTI-FUNCTIONAL TOUCHSCREEN WITH CARPLAY COMPATIBILITY",
			fr: "ÉCRAN TACTILE 9” MULTIFONCTIONNEL AVEC COMPATIBILITÉ CARPLAY",
		},
		p_features_screen: {
			en: "Elevate your off-road adventures with our 9” touchscreen. Compatible with Apple Carplay & Android Auto, speed, gear indications, lighting controls, and an odometer. Dive into entertainment with radio and music options, connect via Bluetooth, and navigate with ease utilizing the back-up camera display.",
			fr: "Rehaussez vos aventures tout-terrain avec notre écran tactile 9”. Compatible avec Apple Carplay & Android Auto, indications de vitesse, de rapport de conduite, commandes d'éclairage et compteur kilométrique. Plongez dans le divertissement avec des options radio et musique, connectez-vous via Bluetooth et naviguez facilement en utilisant l'affichage de la caméra de recul.",			
		},
		t_features_tires: {
			en: "RADIAL TIRES",
			fr: "PNEUS RADIAUX",
		},
		p_features_tires: {
			en: "Experience a blend of form and function with our 14-inch alloy wheels. Carefully designed, their flat treads ensure that greens remain intact. Intricate sips on the tread effectively disperse water, contributing to impeccable traction, precise cornering and reliable braking. These tires, with their low profile and 4-ply construction, are not only lightweight, but also feature a more compact footprint than typical off-road tires.",
			fr: "Découvrez un mélange de forme et de fonction avec nos roues en alliage de 14 pouces. Conçues avec soin, leurs bandes de roulement plates garantissent que les greens restent intacts. Les lamelles complexes sur la bande de roulement dispersent efficacement l'eau, contribuant à une traction impeccable, un virage précis et un freinage fiable. Ces pneus, avec leur profil bas et leur construction à 4 plis, sont non seulement légers, mais présentent également une empreinte plus compacte que les pneus tout-terrain typiques.",
		},
		t_features_seats: {
			en: "HIGH-END LUXURY SEATS",
			fr: "SIÈGES DE LUXE HAUT DE GAMME",
		},
		p_features_seats: {
			en: "Seat Back Cover Set: Integrated with handrail, cup holder, storage pocket, USB charging ports, etc. Standard Seat Belts: Standard three-point seat belts for all seats keep you safely strapped in while driving and driving. Rotatable armrest: It can rotate 90 degrees and provide ergonomic support for your cantilevered elbows.",
			fr: "Ensemble de couverture de dossier de siège : Intégré avec main courante, porte-gobelet, poche de rangement, ports de charge USB, etc. Ceintures de sécurité standard : Les ceintures de sécurité trois points standard pour tous les sièges vous maintiennent en sécurité pendant la conduite. Accoudoir rotatif : Il peut pivoter à 90 degrés et fournir un support ergonomique pour vos coudes en porte-à-faux.",
		},
		t_features_lighting: {
			en: "LED LIGHTING",
			fr: "ÉCLAIRAGE LED",
		},
		p_features_lighting: {
			en: "Our personal transportation vehicles come standard with LED lights: high beams, low beams, daytime running lights, turn signals and brake lights for a brighter ride. Our lights are more powerful with less battery drain, delivering a 2-3 times wider field of vision compared to our competitors, allowing you to enjoy the ride worry-free, even after the sun goes down.",
			fr: "Nos véhicules de transport personnel sont équipés de série de lumières LED : feux de route, feux de croisement, feux de jour, clignotants et feux de freinage pour une conduite plus lumineuse. Nos lumières sont plus puissantes avec une consommation de batterie réduite, offrant un champ de vision 2 à 3 fois plus large par rapport à nos concurrents, vous permettant de profiter de la conduite sans souci, même après le coucher du soleil.",
		},
		t_features_steering: {
			en: "ADJUSTABLE STEERING COLUMN",
			fr: "COLONNE DE DIRECTION RÉGLABLE",
		},
		p_features_steering: {
			en: "The Luxor's adjustable steering wheel is specially designed to make driving easier and allow the driver to have more control over driving view/distance between steering wheel and driver/the feel of steering wheel grips. It works by tilting up and down, depending on what makes it easier for the driver to drive.",
			fr: "Le volant réglable du Luxor est spécialement conçu pour faciliter la conduite et permettre au conducteur de mieux contrôler la vue de conduite/la distance entre le volant et le conducteur/la sensation des poignées du volant. Il fonctionne en s'inclinant vers le haut et vers le bas, en fonction de ce qui facilite la conduite pour le conducteur.",
		},
		t_features_storage: {
			en: "REAR STORAGE COMPARTMENT",
			fr: "COMPARTIMENT DE RANGEMENT ARRIÈRE",
		},
		p_features_storage: {
			en: "The rear storage compartment is configured as standard for all Luxor models, the golf bag holder is an optional accessory to allow you to convert your Luxor for different personal purposes.* The glove boxes and rear storage compartment use keys common for all locks.",
			fr: "Le compartiment de rangement arrière est configuré de série pour tous les modèles Luxor, le porte-sac de golf est un accessoire optionnel pour vous permettre de convertir votre Luxor à des fins personnelles différentes.* Les boîtes à gants et le compartiment de rangement arrière utilisent des clés communes pour toutes les serrures.",
		},
		t_features_2_2_storage: {
			en: "REAR STORAGE COMPARTMENT",
			fr: "COMPARTIMENT DE RANGEMENT ARRIÈRE",
		},
		p_features_2_2_storage: {
			en: "Travel lighter, enjoy more. Under the rear flip seat, a concealed nook safeguards your items, blending seamlessly with your leisure. It offers a neat solution, keeping your essentials accessible yet out of sight.",
			fr: "Voyagez plus léger, profitez-en davantage. Sous le siège arrière pliable, un recoin dissimulé protège vos objets, s'intégrant parfaitement à vos loisirs. Il offre une solution soignée, gardant vos essentiels accessibles tout en étant hors de vue.",
		},
		t_features_soundBar: {
			en: "SOUND BAR",
			fr: "BARRE DE SON",
		},
		p_features_soundBar: {
			en: "The soundbar has a compact size that can be connected wirelessly via the screen with adjustable lighting modes with LED lights and beautiful sound quality.",
			fr: "La barre de son a une taille compacte qui peut être connectée sans fil via l'écran avec des modes d'éclairage réglables avec des lumières LED et une belle qualité sonore.",
		},
		t_features_enclosure: {
			en: "OPTIONAL ALL-WEATHER ENCLOSURE",
			fr: "ENCEINTE TOUT TEMPS OPTIONNELLE",
		},
		p_features_enclosure: {
			en: "Improve your comfort with our optional all-weather shelter, designed to protect you from the unpredictability of nature, whether it's intense sun, rain or gusty winds. Beyond personal comfort, this protective layer extends the life of your interior equipment, protecting it from external wear and thus reducing maintenance expenses.",
			fr: "Améliorez votre confort avec notre abri tout temps optionnel, conçu pour vous protéger de l'imprévisibilité de la nature, qu'il s'agisse d'un soleil intense, de la pluie ou de vents violents. Au-delà du confort personnel, cette couche protectrice prolonge la durée de vie de votre équipement intérieur, le protégeant de l'usure externe et réduisant ainsi les dépenses de maintenance.",
		},
		t_features_rearArmrest: {
			en: "REAR ARMREST WITH BUILT-IN STORAGE",
			fr: "ACCOTOIR ARRIÈRE AVEC RANGEMENT INTÉGRÉ",
		},
		p_features_rearArmrest: {
			en: "Maximize comfort and convenience with an integrated storage compartment, offering passengers enhanced comfort while providing a sleek solution for organizing personal items, ensuring an enjoyable ride.",
			fr: "Maximize comfort and convenience with an integrated storage compartment, offering passengers enhanced comfort while providing a sleek solution for organizing personal items, ensuring an enjoyable ride.",
		},
		t_features_flipRearSeats: {
			en: "FLIP-FLOP REAR SEAT",
			fr: "SIÈGE ARRIÈRE PLIABLE",
		},
		p_features_flipRearSeats: {
			en: "Rear Handrail with footrest: Enhanced stability and comfort with a built-in footrest, providing extra support and relaxation. Built-in Storage Box and Lid: Located underneath the rear flip-flop seat, maximizing space efficiency.",
			fr: "Poignée arrière avec repose-pieds : Stabilité et confort améliorés avec un repose-pieds intégré, offrant un soutien et une détente supplémentaires. Boîte de rangement intégrée et couvercle : Située sous le siège arrière pliable, maximisant l'efficacité de l'espace.",
		},
		t_features_safetyBelts: {
			en: "SAFETY BELT",
			fr: "CEINTURE DE SÉCURITÉ",
		},
		p_features_safetyBelts: {
			en: "Ride safely, worry less. The standard 3-point safety belt is engineered for your protection, keeping your passengers safely bulked up while riding. It combines comfort with safety, ensuring peace of mind on every journey.",
			fr: "Roulez en toute sécurité, inquiétez-vous moins. La ceinture de sécurité standard à 3 points est conçue pour votre protection, maintenant vos passagers en sécurité pendant la conduite. Elle allie confort et sécurité, garantissant une tranquillité d'esprit à chaque trajet.",
		},
		t_features_offRoad_tires: {
			en: "SILENT TIRES WITH OFFROAD THREAD",
			fr: "PNEUS SILENCIEUX AVEC FILETAGE TOUT-TERRAIN",
		},
		p_features_offRoad_tires: {
			en: "Venture off the beaten path with confidence thanks to silent tires boasting robust off-road treads, designed specifically for the Luxor 2+2. These tires don't just offer enhanced durability and stability, but they also exude style. Rely on their premium compounds for extended tread life and an elevated driving experience.",
			fr: "Osez l'aventure hors des sentiers battus en toute confiance grâce à des pneus silencieux dotés de robustes filets tout-terrain, spécialement conçus pour le Luxor 2+2. Ces pneus offrent non seulement une durabilité et une stabilité accrues, mais ils dégagent également du style. Comptez sur leurs composés de qualité supérieure pour une durée de vie prolongée de la bande de roulement et une expérience de conduite améliorée.",
		},
		h2_spec_title: {
			en: "SPECIFICATIONS",
			fr: "SPÉCIFICATIONS",
		},
		h3_spec_dimensions: {
			en: "DIMENSIONS",
			fr: "DIMENSIONS",
		},
		h3_spec_power: {
			en: "POWER",
			fr: "PUISSANCE",
		},
		h3_spec_features: {
			en: "FEATURES",
			fr: "FONCTIONNALITÉS",
		},
		list_spec_power: {
			en: [
				"48 V 110 Ah Lithium battery",
				"6.3 kW motor with EM brake",
				"400 A, AC controller",
				"Integrated 25 A charger",
				"Maximum speed ≥ 40 km/h (25 mph)"
			],
			fr: [
				"Batterie lithium 48 V 110 Ah",
				"Moteur 6.3 kW avec frein EM",
				"Contrôleur 400 A, AC",
				"Chargeur intégré 25 A",
				"Vitesse maximale ≥ 40 km/h (25 mph)"
			],
		},
		list_spec_features: {
			en: [
				"Adjustable steering column",
				"Sound system with 10 speakers",
				"Luxury two-tone seats with foldable armrests",
				"Seat back cover with cup holder/handrail, charging port, storage pocket, etc.",
				"Multifunctional dashboard",
				"Rear storage box",
				"EM brake",
				"LED lighting",
				"Foldable windshield with sliding sub-windows",
				"Automotive-style rear bumper",
				"14×7” Aluminum Wheel/ 23×10-14 Silent Tire with Off-road Thread",
				"Automotive E-coat chassis",
				"9” Multi-functional Touchscreen (Apple Carplay & Android Auto Compatibility, Speed display, Driving Gear indication, Lights, Odometer, Radio, Music, Bluetooth Connection, Back-up camera, etc.)",
			],
			fr: [
				"Colonne de direction réglable",
				"Système audio avec 10 haut-parleurs",
				"Sièges de luxe bicolores avec accoudoirs pliants",
				"Couverture de dossier de siège: Intégré avec main courante, porte-gobelet, poche de rangement, ports de charge USB, etc.",
				"Tableau de bord multifonctionnel",
				"Coffre de rangement arrière",
				"Frein EM",
				"Éclairage LED",
				"Pare-brise pliable avec sous-fenêtres coulissantes",
				"Pare-chocs arrière de style automobile",
				"Roue en aluminium 14×7″/pneu silencieux 23×10-14 avec filetage tout-terrain",
				"Châssis E-coat de style automobile",
				"Écran tactile multifonctionnel 9″ (affichage de la vitesse, Indication du rapport de conduite, lumières, compteur kilométrique, radio, musique, connexion Bluetooth, affichage de l'image de la caméra de recul, etc.)",
			],
		},
		h2_shrink_golfBags: {
			en: "OPTIONAL GOLF BAG HOLDER",	
			fr: "PORTE-BAGAGES DE GOLF OPTIONNEL",
		},
		p_shrink_golfBags: {
			en: "",
			fr: "",
		},
		h2_shrink_cupHolders: {
			en: "CUP HOLDERS",
			fr: "PORTE-GOBELETS",
		},
		p_shrink_cupHolders: {
			en: "Keep your drinks secure with these cup holders.",
			fr: "Gardez vos boissons en sécurité avec ces porte-gobelets.",
		},
		h2_shrink_dashStorage: {
			en: "DASHBOARD",
			fr: "TABLEAU DE BORD",
		},
		p_shrink_dashStorage: {
			en: "Store your items conveniently on the dashboard.",
			fr: "Rangez vos articles commodément sur le tableau de bord.",
		},
		h2_shrink_storage: {
			en: "STORAGE",
			fr: "RANGEMENT",
		},
		p_shrink_storage: {
			en: "Ample storage space for all your needs.",
			fr: "Un espace de rangement ample pour tous vos besoins.",
		},
		h2_shrink_usbPorts: {
			en: "USB PORTS",
			fr: "PORTS USB",
		},
		p_shrink_usbPorts: {
			en: "Charge your devices with multiple USB ports.",
			fr: "Chargez vos appareils avec plusieurs ports USB.",
		},
		h2_shrink_golfCompartment: {
			en: "GOLF BALL HOLDER",
			fr: "PORTE-BALLES DE GOLF",
		},	
		p_shrink_golfCompartment: {
			en: "Keep you ready for golfing, Holes for four golf balls",
			fr: "Gardez-vous prêt pour le golf, trous pour quatre balles de golf",
		},
		h2_shrink_mirrorFlashers: {
			en: "POWERED REAR VIEW MIRRORS",
			fr: "MIROIRS DE VUE ARRIÈRE ÉLECTRIQUES",
		},
		p_shrink_mirrorFlashers: {
			en: "Powered Rear View mirrors with turn signal indicator lights",
			fr: "Miroirs de vue arrière électriques avec clignotants",
		},
		h2_shrink_chargerPlug: {
			en: "CHARGING SOCKET",
			fr: "PRISE DE CHARGE",
		},
		p_shrink_chargerPlug: {
			en: "Heavy duty charging socket,for higher current flow ,better heat dissipation",
			fr: "Prise de charge robuste, pour un meilleur débit de courant, une meilleure dissipation de la chaleur",
		},
		h2_shrink_soundBar: {
			en: "SOUND SYSTEM WITH 10 SPEAKERS",
			fr: "SYSTÈME AUDIO AVEC 10 HAUT-PARLEURS",
		},
		p_shrink_soundBar: {
			en: "Wirelessly connect to the screen with adjustable lighting modes and LED lights",
			fr: "Connectez-vous sans fil à l'écran avec des modes d'éclairage réglables et des lumières LED",
		},
		h2_shrink_handles: {
			en: "CEILING HANDLE",
			fr: "POIGNÉE DE PLAFOND",
		},
		p_shrink_handles: {
			en: "",
			fr: "",
		},

	},
} as const;

type TranslationKeys = typeof translations.luxorSeries.h1_title;
export type Language = keyof TranslationKeys;
